import { digitsOnlyBeforeInput } from '@/helpers/inputHelpers';
import { PalmettoTextInput } from '@palmetto/dsm-components';
import type { ReactNode } from 'react';

const EXPIRY_MASK_OPTIONS = { mask: '__/____', replacement: { _: /\d/ } } as const;

interface CustomerDirectPaymentCardFormProps {
  cardNumber: string;
  onCardNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  cardLeadingIcon: ReactNode;
  cardNumberError: string | null;
  expiry: string;
  onExpiryChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  expiryError: string | null;
  cvv: string;
  onCvvChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  cvvError: string | null;
  zip: string;
  onZipChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  zipError: string | null;
  nameOnCard: string;
  onNameOnCardChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  nameOnCardError: string | null;
}

export function CustomerDirectPaymentCardForm({
  cardNumber,
  onCardNumberChange,
  cardLeadingIcon,
  cardNumberError,
  expiry,
  onExpiryChange,
  expiryError,
  cvv,
  onCvvChange,
  cvvError,
  zip,
  onZipChange,
  zipError,
  nameOnCard,
  onNameOnCardChange,
  nameOnCardError,
}: CustomerDirectPaymentCardFormProps) {
  return (
    <div className="dp-inputs flex flex-col gap-10">
      <PalmettoTextInput
        label="Card number"
        value={cardNumber}
        onChange={onCardNumberChange}
        onBeforeInput={digitsOnlyBeforeInput}
        placeholder="Card number"
        maxLength={19}
        inputMode="numeric"
        leadingIcon={cardLeadingIcon}
        validationMessage={cardNumberError ? { type: 'error', text: cardNumberError } : undefined}
      />
      <div className="grid grid-cols-2 gap-10">
        <PalmettoTextInput
          label="Expiration"
          value={expiry}
          onChange={onExpiryChange}
          placeholder="Expiration"
          inputMode="numeric"
          maskOptions={EXPIRY_MASK_OPTIONS}
          validationMessage={expiryError ? { type: 'error', text: expiryError } : undefined}
        />
        <PalmettoTextInput
          label="CVV"
          value={cvv}
          onChange={onCvvChange}
          onBeforeInput={digitsOnlyBeforeInput}
          placeholder="CVV"
          maxLength={4}
          inputMode="numeric"
          validationMessage={cvvError ? { type: 'error', text: cvvError } : undefined}
        />
      </div>
      <PalmettoTextInput
        label="Billing postal code"
        value={zip}
        onChange={onZipChange}
        onBeforeInput={digitsOnlyBeforeInput}
        placeholder="Billing postal code"
        maxLength={5}
        inputMode="numeric"
        validationMessage={zipError ? { type: 'error', text: zipError } : undefined}
      />
      <PalmettoTextInput
        label="Name on card"
        value={nameOnCard}
        onChange={onNameOnCardChange}
        placeholder="Name on card"
        validationMessage={nameOnCardError ? { type: 'error', text: nameOnCardError } : undefined}
      />
    </div>
  );
}
